import $ from "jquery";

export default function rdtsSimpleAccordion(accordion) {
    const accordionElems = accordion.find('.accordion-section');
    accordionElems.each(function () {
        const accElem = $(this);

        const accHeader = accElem.find('h3.accordion-header').first();
        const accContent = accElem.find('.accordion-content').first();

        if (accContent.attr('aria-expanded') == 'false') {
            accContent.slideUp();
        }

        accHeader.on('click', function (e) {
            e.preventDefault();
            accHeader.attr('aria-selected', true);
            accContent.attr('aria-expanded', true);
            accordion.find('.accordion-section h3.accordion-header').not(accHeader).attr('aria-selected', false);
            accordion.find('.accordion-section .accordion-content').not(accContent).attr('aria-expanded', false).slideUp(100);
            accContent.slideDown(100, function () {
                accElem.get(0).scrollIntoView({ behavior: 'smooth' }, true);
            });
        });
    });
}